export default __webpack_public_path__ + "static/media/ws-button.eef5af66.svg";